import { SwipeableDrawer } from "@mui/material";
import type { FC } from "react";
import { SwapStaff } from "../../../components/SwapStaff/SwapStaff";
import { useHandleNurseChange } from "../../../hooks/useHandleNurseChange";
import { type NurseInShiftDetails, ShiftType } from "../../../utils/models";

interface SwapDrawerProps {
	open: boolean;
	onClose: () => void;
	shift: NurseInShiftDetails | null;
	weekIndex: number;
}

const SwapDrawer: FC<SwapDrawerProps> = ({ open, onClose, shift, weekIndex }) => {
	const { swapBetweenShifts } = useHandleNurseChange();
	if (!shift) {
		return null;
	}

	const shiftIndex = shift.nurse.shiftType === ShiftType.Night ? 1 : 0;

	return (
		<SwipeableDrawer
			data-testid="swap-drawer"
			anchor="bottom"
			onOpen={() => {}}
			open={open}
			onClose={onClose}
			slotProps={{
				paper: {
					sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16 },
				},
			}}
		>
			<SwapStaff
				weekIndex={weekIndex}
				dayIndex={shift.dayIndex}
				shiftIndex={shiftIndex}
				onClose={onClose}
				shift={shift.nurse}
				handleSwap={async (originShiftId, targetShiftId) => {
					await swapBetweenShifts({ originShiftId, targetShiftId });
					onClose();
				}}
			/>
		</SwipeableDrawer>
	);
};

export default SwapDrawer;
